import {
	reInfoOrgConstructionMaterialPricesPerPeriodConstants
}from "./constants"
import actions from "../../actions"

const initialState = {
	isSending      : false,
	paged          : {},
	changed        : null,
	isFileSending  : false,
	isAuditSending : false,
	pagedAudit     : {}
}

export default function (state = initialState, action){
	switch (action.type){
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.GetPaged.REQUEST):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.Delete.REQUEST):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.DeleteFilteredPrices.REQUEST):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.DeleteSelectedPrices.REQUEST):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.Update.REQUEST):
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.GetPaged.FAILURE):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.Delete.FAILURE):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.DeleteFilteredPrices.FAILURE):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.DeleteSelectedPrices.FAILURE):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.Update.FAILURE):
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.GetPagedAudit.REQUEST):
			return {
				...state,
				isAuditSending: true
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.GetPagedAudit.SUCCESS):
			return {
				...state,
				isAuditSending : false,
				pagedAudit     : action.payload.result
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.GetPagedAudit.FAILURE):
			return {
				...state,
				isAuditSending: false
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.GetPagedAudit.CLEAR):
			return {
				...state,
				isAuditSending : false,
				pagedAudit     : {}
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.GetPaged.SUCCESS):
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.Delete.SUCCESS):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.DeleteFilteredPrices.SUCCESS):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.DeleteSelectedPrices.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.Update.SUCCESS):
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.GetFile.REQUEST):
			return {
				...state,
				isFileSending: true
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.GetFile.SUCCESS):
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.GetFile.FAILURE):
			return {
				...state,
				isFileSending: false
			}
		case (reInfoOrgConstructionMaterialPricesPerPeriodConstants.CLEAR):
			return {
				...state,
				error          : null,
				isSending      : false,
				paged          : {},
				changed        : null,
				isFileSending  : false,
				isAuditSending : false,
				pagedAudit     : {}
			}
		default:
			return state
	}
}